import React, { useState } from "react";
import { Dropdown, Space } from 'antd';
const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  
const currentYear = new Date().getFullYear();
const startYear = 2020;

const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);

  
const Timesheets = () => {
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [selectedYear, setSelectedYear] = useState(currentYear);

    const items = years.map((year) => ({
        label: <span>{year}</span>,
        key: year.toString(),
        onClick: () => setSelectedYear(year), 
    }));
    return (
        <div className="timesheets">
            <h4>Timesheets</h4>
            <div className="yearFilter">
                <Dropdown menu={{ items }} trigger={['click']}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                        {selectedYear} 
                        <i className="fas fa-caret-down" />
                        </Space>
                    </a>
                </Dropdown>
            </div>
            <div className="month-selector">
                {months.map((month, index) => (
                    <div
                    key={index}
                    className={`month-item ${index === selectedMonth ? "active" : ""}`}
                    onClick={() => setSelectedMonth(index)}
                    >
                    {month}
                    </div>
                ))}
            </div>
            <div className="listOfRecords">
                <ul>
                    <li class="record">
                        <span class="date">2025-04-01</span>
                        <span class="workedHours">8h</span>
                    </li>
                    <li class="record"><span class="date">2025-04-02</span><span class="workedHours">7h</span></li>
                    <li class="record"><span class="date">2025-04-03</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-04</span><span class="workedHours">6h</span></li>
                    <li class="record"><span class="date">2025-04-05</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-06</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-07</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-08</span><span class="workedHours">7h</span></li>
                    <li class="record"><span class="date">2025-04-09</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-10</span><span class="workedHours">6h</span></li>
                    <li class="record"><span class="date">2025-04-11</span><span class="workedHours">7h</span></li>
                    <li class="record"><span class="date">2025-04-12</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-13</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-14</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-15</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-16</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-17</span><span class="workedHours">6h</span></li>
                    <li class="record"><span class="date">2025-04-18</span><span class="workedHours">7h</span></li>
                    <li class="record"><span class="date">2025-04-19</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-20</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-21</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-22</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-23</span><span class="workedHours">7h</span></li>
                    <li class="record"><span class="date">2025-04-24</span><span class="workedHours">6h</span></li>
                    <li class="record"><span class="date">2025-04-25</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-26</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-27</span><span class="workedHours">0h</span></li>
                    <li class="record"><span class="date">2025-04-28</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-29</span><span class="workedHours">8h</span></li>
                    <li class="record"><span class="date">2025-04-30</span><span class="workedHours">7h</span></li>
                </ul>
            </div>
        </div>
    )
}

export default Timesheets;